import { Group } from '@ekhodealer/ekho-common/rev';

import { StatBox } from '@common/components/StatBox';
import { formatCurrency, formatDays } from '@common/lib/currency';
import { PLACEHOLDER } from '@common/lib/strings';

import { useGetLeadStats } from '../api/useGetLeadStats';

export function LeadStats() {
	const { data: stats, isLoading } = useGetLeadStats();

	// Use placeholder if loading
	const placeholder = isLoading ? PLACEHOLDER : undefined;

	return (
		<Group itemsSpacing='16' noWrap itemsAlignX='stretch' itemsAlignY='stretch'>
			<StatBox
				title='Total lead value'
				detail={formatCurrency(stats?.totalLeadValue, placeholder, false)}
			/>
			<StatBox
				title='Open lead value'
				detail={formatCurrency(stats?.openLeadValue, placeholder, false)}
			/>
			<StatBox
				title='Closed won lead value'
				detail={formatCurrency(stats?.closedWonLeadValue, placeholder, false)}
			/>
			<StatBox
				title='Avg open lead age'
				detail={formatDays(stats?.avgOpenLeadAge, placeholder)}
			/>
		</Group>
	);
}
